import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import { Badge } from './ui/Badge';
import { FileText, Lightbulb, Video, Sparkles } from 'lucide-react';
interface Activity {
  id: string;
  type: 'inspiration' | 'idea' | 'concept' | 'video';
  title: string;
  time: string;
  category?: string;
}
const MOCK_ACTIVITIES: Activity[] = [{
  id: '1',
  type: 'video',
  title: 'Added "The Art of Storytelling in Modern Marketing"',
  time: '2 hours ago',
  category: 'Storytelling'
}, {
  id: '2',
  type: 'idea',
  title: 'Started new idea: "Q4 Campaign Concepts"',
  time: '5 hours ago',
  category: 'Marketing'
}, {
  id: '3',
  type: 'concept',
  title: 'Created concept: "Minimalist Brand Refresh"',
  time: '1 day ago',
  category: 'Design'
}, {
  id: '4',
  type: 'inspiration',
  title: 'Saved inspiration from "Viral Content Formulas"',
  time: '2 days ago',
  category: 'Social Media'
}, {
  id: '5',
  type: 'video',
  title: 'Added "Color Psychology in Advertising"',
  time: '3 days ago',
  category: 'Marketing'
}];
const getActivityIcon = (type: Activity['type']) => {
  switch (type) {
    case 'video':
      return Video;
    case 'idea':
      return Lightbulb;
    case 'concept':
      return Sparkles;
    case 'inspiration':
      return FileText;
  }
};
export function ActivityFeed() {
  return <Card className="border-gray-200" data-id="element-1">
      <CardHeader className="pb-3" data-id="element-2">
        <CardTitle className="text-xl font-bold" data-id="element-3">Recent Activity</CardTitle>
      </CardHeader>
      <CardContent className="p-0" data-id="element-4">
        <div className="divide-y divide-gray-100" data-id="element-5">
          {MOCK_ACTIVITIES.map(activity => {
          const Icon = getActivityIcon(activity.type);
          return <div key={activity.id} className="p-4 hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-6">
                <div className="flex items-start gap-3" data-id="element-7">
                  <div className="h-10 w-10 rounded-lg bg-[#139191]/10 flex items-center justify-center flex-shrink-0" data-id="element-8">
                    <Icon className="h-5 w-5 text-[#139191]" data-id="element-9" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-10">
                    <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-11">
                      {activity.title}
                    </p>
                    <div className="flex items-center gap-2" data-id="element-12">
                      <p className="text-xs text-gray-500" data-id="element-13">{activity.time}</p>
                      {activity.category && <>
                          <span className="text-gray-300" data-id="element-14">•</span>
                          <Badge variant="outline" className="text-xs border-gray-200 text-gray-600" data-id="element-15">
                            {activity.category}
                          </Badge>
                        </>}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </CardContent>
    </Card>;
}